import {
    type UploadTokenResponseType,
    type UploadTokenRequestType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForEventCover = async (params: UploadTokenRequestType): Promise<UploadTokenResponseType> => {
    return await request<UploadTokenResponseType>("/events/getUploadTokenForEventCover", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForEventCover;
